import { useDispatch, useSelector } from "react-redux";
import React from "react";
import { buyGift, closeConfirmGiftPopup, setRemainPoints } from "../../../redux/actions";
import { ConfirmPopup } from "../confirmPopup/ConfirmPopup";
import hyphen from "../../../utils/hyphen";

export const ConfirmGiftPopup = () => {
    const dispatch = useDispatch()
    const lang = useSelector(state => state.app.currentLang);
    const gameId = useSelector(state => state.game.gameShop.settings?.id);
    const giftPopup = useSelector(state => state.user.giftPopup);
    const confirmGiftPopup = useSelector(state => state.app.confirmGiftPopup);
    const confirmGiftPopupLoading = useSelector(state => state.app.confirmGiftPopupLoading);

    function close() {
        dispatch(closeConfirmGiftPopup());
        dispatch(setRemainPoints(null));
    }
    function confirm(){
        dispatch(buyGift(gameId, giftPopup.id))
    }
    if (!confirmGiftPopup) return (null)
    else return (
        <ConfirmPopup
            confirm={confirm}
            close={close}
            title={lang.confirm.title.shop+' '+hyphen(giftPopup.name)+'?'}
            price={giftPopup.price}
            loading={confirmGiftPopupLoading}>
        </ConfirmPopup>
    )
}